// Sections de la fiche client 360° — ordre par défaut, libellés, et normalisation
// de la préférence utilisateur (code PAGE → data.client360 = { order, hidden }).

export const CLIENT360_DEFAULT_ORDER = [
  'identite',
  'environnement',
  'contacts',
  'affaires',
  'devis',
  'commandes',
  'factures',
  'eligibilite',
  'technique',
  'tickets',
  'activite',
  'filiales',
] as const

export const CLIENT360_SECTION_LABELS: Record<string, string> = {
  identite: 'Identité',
  environnement: 'Environnement',
  contacts: 'Contacts',
  affaires: 'Affaires',
  devis: 'Devis',
  commandes: 'Commandes',
  factures: 'Factures',
  eligibilite: 'Éligibilités',
  technique: 'Services & Technique',
  tickets: 'Tickets',
  activite: 'Activité',
  filiales: 'Filiales',
}

// Sections toujours visibles (non masquables).
export const CLIENT360_ALWAYS_VISIBLE = ['identite']

export interface Client360Pref {
  order: string[]
  hidden: string[]
}

/**
 * Normalise la préférence stockée en { order, hidden } robuste :
 * - complète l'ordre avec les sections manquantes (dans l'ordre par défaut) ;
 * - filtre les ids inconnus ;
 * - empêche de masquer les sections toujours visibles ;
 * - migre l'ancien format `client360TabsOrder` (simple tableau d'ordre).
 */
export function normalizeClient360Pref(raw: any): Client360Pref {
  const defaults = [...CLIENT360_DEFAULT_ORDER]

  const rawOrder: unknown = Array.isArray(raw?.order)
    ? raw.order
    : Array.isArray(raw?.client360TabsOrder)
      ? raw.client360TabsOrder
      : Array.isArray(raw)
        ? raw
        : []

  const known = (rawOrder as string[]).filter((id) => defaults.includes(id as any))
  const missing = defaults.filter((id) => !known.includes(id))
  const order = [...known, ...missing]

  const hidden = Array.isArray(raw?.hidden)
    ? (raw.hidden as string[]).filter(
        (id) => defaults.includes(id as any) && !CLIENT360_ALWAYS_VISIBLE.includes(id),
      )
    : []

  return { order, hidden }
}
